import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './WorkpackStatus.module.scss';
import { getStatusClass, getStatusId, WORKPACK_DISPLAY_STATUS } from '../../ListWorkpackPage/utils/workpackStatusConstants';
import Icon from '@mdi/react';
import { mdiHelpCircle } from '@mdi/js';
import Tooltip from 'client/components/aria/Tooltip/Tooltip';
import { useState } from 'react';

const WorkpackStatus = ({ displayStatus, daysRemaining, ...props }) => {
    const intl = useIntl();

    const [showTooltip, setShowTooltip] = useState(false);

    const statusId = getStatusId(displayStatus);
    const statusClass = getStatusClass(displayStatus);
    const isCreating = displayStatus === WORKPACK_DISPLAY_STATUS.CREATING;
    const hasFailed = displayStatus === WORKPACK_DISPLAY_STATUS.FAILED;
    const hasDaysRemaining = displayStatus === WORKPACK_DISPLAY_STATUS.AVAILABLE_DAYS_LEFT && daysRemaining >= 0;
    const testId = props['data-testid'];

    const getDaysRemainingText = () => {
        if (daysRemaining === 0) {
            return intl.formatMessage({ id: 'listWorkpackPage.lessThanADayLeft' });
        }
        return intl.formatMessage(
            { id: 'listWorkpackPage.daysLeft' },
            { days: daysRemaining }
        );
    };

    return (
        <div className={`${styles.status} govuk-task-list__status`} data-testid={testId}>
            <div className={styles.tagWrapper}>
                <strong className={statusClass}>
                    <FormattedMessage id={statusId} />
                </strong>
                {isCreating && <span className={styles.creatingLoader} aria-hidden="true" />}
            </div>
            {hasFailed && (
                <div
                    onMouseOver={() => setShowTooltip(true)}
                    onMouseOut={() => setShowTooltip(false)}
                    className={styles.failedTooltipWrapper}
                    data-testid={`${testId}.failed`}
                >
                    <Icon path={mdiHelpCircle} size={1.1} className={styles.help} data-testid={`${testId}.failed.icon`} />
                    <Tooltip
                        isOpen={showTooltip}
                        className={styles.failedTooltip}
                        contentClassName={styles.failedTooltipContent}
                        data-testid={`${testId}.failed.tooltip`}
                    >
                        <FormattedMessage id="listWorkpackPage.failedTooltipText" />
                    </Tooltip>
                </div>
            )}
            {hasDaysRemaining && (
                <span className={`${styles.daysRemaining} govuk-hint govuk-!-font-size-16`}>
                    {getDaysRemainingText()}
                </span>
            )}
        </div>
    );
};

WorkpackStatus.propTypes = {
    displayStatus: PropTypes.oneOf(Object.values(WORKPACK_DISPLAY_STATUS)),
    daysRemaining: PropTypes.number.isRequired,
    'data-testid': PropTypes.string
};

WorkpackStatus.defaultProps = {
    displayStatus: WORKPACK_DISPLAY_STATUS.EXPIRED,
    'data-testid': 'workpackStatus'
};

export default WorkpackStatus;
